export const FAVORITE_LIST_LIMIT = 5;
